import { utils, config } from "../../../../studentportal-sdk";

export const scheduleLiveClass = async (formdata) => {
  try {
    const { data } = await utils
      .apiConnect()
      .post(config.domains.endpoints.postLiveClassApi, formdata);
    return {
      status: true,
      data: data.data,
      message: "",
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

export const getLiveClass = async() => {
  try{
    const { data } = await utils
    .apiConnect()
    .get(`${config.domains.endpoints.getLiveClassApi}`);
    
    return {
      status: true,
      data: data.data,
      message: "",
    };
  }catch(error){
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
}

export const updateLiveClass = async (id, formData) => {
  try {
    const { data } = await utils
      .apiConnect()
      .put(`${config.domains.endpoints.updateLiveClassApi}${id}`, formData);
    return {
      status: true,
      data: data.data,
      message: "",
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

// Function to delete a live class by ID
// export const deleteLiveClassById = async (id) => {
//   try {
//     const { data } = await utils
//       .apiConnect()
//       .delete(`${config.domains.endpoints.deleteLiveClassApi}${id}`);
//     return {
//       status: true,
//       data: data.data,
//       message: data.message || "Live class deleted successfully.",
//     };
//   } catch (error) {
//     return {
//       status: false,
//       message:
//         error?.response?.data?.message ||
//         error.message ||
//         "Failed to delete live class.",
//       error: true,
//     };
//   }
// };
